<div class="gauge-chart-container">
  <div #chartContainer [id]="'gauge-chart-' + chartId" class="chart-container"></div>

  <!-- Legend section -->
  <div class="gauge-legend-container" *ngIf="showLegend && legendData.length > 0">
    <div class="d-flex justify-content-center flex-wrap">
      <div
        class="legend-item"
        *ngFor="let pointer of legendData"
        (click)="onLegendClick(pointer)"
        [ngClass]="{ 'legend-disabled': pointer.hideLegends }"
      >
        <span class="legend-dot" [style.background-color]="pointer.color"></span>
        <span class="legend-label">{{ pointer.label }}</span>
      </div>
    </div>
  </div>
</div>
